import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  // base: '',
  mode: 'history',
  routes: [{
    path: '/',
    redirect: '/cardactivate'
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/Home'),
    meta: {
      keepAlive: true,
      title: '首页',
      showTabbar: true
    }
  }, 
  {
    path: '/arrondi/:id',
    name: 'arrondi',
    component: () => import('@/views/arrondi'),
    meta: {
      keepAlive: false,
      title: '课程平台',
      showTabbar: true,
      showHeader:true,
    }
  },
  {
    path: '/mine',
    name: 'mine',
    component: () => import('@/views/Mine'),
    meta: {
      keepAlive: true,
      title: '个人中心',
      showTabbar: true,
      showHeader:true,
    }
  },
  {
    path: '/myCourses',
    name: 'myCourses',
    component: () => import('@/views/myCourses'),
    meta: {
      keepAlive: false,
      title: '我的课程',
      showTabbar: true,
      showHeader:true,
    }
  },
  {
    path: '/myAccount',
    name: 'myAccount',
    component: () => import('@/views/myAccount'),
    meta: {
      keepAlive: false,
      title: '我的账户',
      showTabbar: false,
      showHeader:true,
    }
  },
  {
    path: '/myOrder',
    name: 'myOrder',
    component: () => import('@/views/myOrder'),
    meta: {
      keepAlive: false,
      title: '我的订单',
      showTabbar: false,
      showHeader:true,
    }
  },
  {
    path: '/Exchange',
    name: 'Exchange',
    component: () => import('@/views/Exchange'),
    meta: {
      keepAlive: false,
      title: '激活记录',
      showTabbar: false,
      showHeader:true,
    }
  },
  {
    path: '/myCourses/details/:id',
    name: 'coursedetails',
    component: () => import("@/views/Coursedetails"),
    meta: {
      keepAlive: false,
      title: '课程详情',
      showTabbar: false,
      showHeader:true,
    }
  },
  {
    path: '/PayCourse',
    name: 'PayCourse',
    component: () => import('@/views/Coursedetails/PayCourse'),
    meta: {
      keepAlive: false,
      title: '支付订单',
      showTabbar: false,
      showHeader:false,
    },
    props : (route) => {
      let {payshow, type, title, payparams,priceParams,wxreturnURL,alireturnURL} = route.query
      return {
        payshow,
        type,
        title,
        payparams: JSON.parse(payparams),
        priceParams: JSON.parse(priceParams),
        wxreturnURL,
        alireturnURL
      }
  }
  },
  {
    path: '/alipay',
    name: 'alipay',
    component: () => import('@/views/Coursedetails/aliPay'),
    meta: {
      keepAlive: false,
      title: '支付宝支付',
      showTabbar: false,
      showHeader:false,
    }
  },
  {
    path: '/aliReturnUrl',
    name: 'aliReturnUrl',
    component: () => import('@/views/Coursedetails/aliReturnUrl'),
    meta: {
      keepAlive: false,
      title: '',
      showTabbar: false,
      showHeader:false,
    }
  },
  {
    path: '/courseActivation',
    name: 'courseActivation',
    component: () => import('@/views/courseActivation'),
    meta: {
      keepAlive: false,
      title: '课程卡激活',
      showTabbar: false,
      showHeader:true,
    }
  },
  {
    path: '/cardactivate',
    name: 'cardactivate',
    component: () => import('@/views/Cardactivate'),
    meta: {
      keepAlive: false,
      title: '学习卡激活',
      showTabbar: false,
      showHeader:false,
    }
  },
  {
    path: '/followofficial',
    name: 'followofficial',
    component: () => import('@/views/FollowOfficial'),
    meta: {
      keepAlive: false,
      title: '学习卡激活',
      showTabbar: false,
      showHeader:false,
    }
  },
  {
    path: '/arrondiList',
    name: 'arrondiList',
    component: () => import('@/views/arrondiList'),
    meta: {
      keepAlive: false,
      title: '学习卡激活',
      showTabbar: false,
      showHeader:false,
    }
  },{
    path: '/certificate',
    name: 'certificate',
    component: () => import('@/views/certificate'),
    meta: {
      keepAlive: false,
      title: '结业证书',
      showTabbar: false,
      showHeader:true,
    }
  },
  {
    path: '/studyNotice/:userId',
    name: 'studyNotice',
    component: () => import('@/views/studyNotice'),
    meta: {
      keepAlive: false,
      title: '退役军人适应性培训课程学习通知',
      showTabbar: false,
      showHeader:false,
    }
  },
  ]
  // scrollBehavior(to, from, savedPosition) {
  //   console.log('savedPosition', savedPosition)
  //   if (savedPosition) {
  //     return savedPosition
  //   } else {
  //     return {
  //       x: 0,
  //       y: 0
  //     }
  //   }
  // }
})


// WEBPACK FOOTER //
// ./src/router/index.js